import { render, staticRenderFns } from "./ss-header-white.vue?vue&type=template&id=0c09542a&scoped=true&"
import script from "./ss-header-white.vue?vue&type=script&lang=js&"
export * from "./ss-header-white.vue?vue&type=script&lang=js&"
import style0 from "./ss-header-white.vue?vue&type=style&index=0&id=0c09542a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c09542a",
  null
  
)

export default component.exports